import styles from '../aside-styles.module.css';
import { Icon } from '../../../../components';
import { Icons } from '../../../../components/Icon/Icon';
import { ReactNode } from 'react';

interface AsideMenuProps {
    open?: boolean;
    children?: ReactNode;
}

const AsideMenuSub = ({ open, children }: AsideMenuProps) => {
    return <div className={`${styles.subMenu} ${open ? styles.open : ''}`}>{children}</div>;
};

export default AsideMenuSub;
